import { memo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import get from "lodash/get";
import { OFFER_CONTRACT_TYPES } from "app/constants";
import { FormattedMessage } from "react-intl";
import OffersOverviewItem from "app/pages/.shared/OffersOverview/OffersOverviewItem";
import { OFFER_TYPES } from "app/constants";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import "./OffersOverview.scss";

const OffersOverview = ({ offers, updateBooking }) => {
	const history = useHistory();
	const { track } = useAnalytics();

	const handleOfferSelect = useCallback(
		offer => () => {
			const { type, label, contractType, uri, config } = offer.pricing;
			if (type === OFFER_TYPES.ACCOMODATION_ONLY) {
				updateBooking({
					offer: { type, label, contractType, uri, negotiated: offer.negotiated },
					config,
					departureCity: {},
					price: undefined,
					publicPrice: undefined,
				});
			} else {
				updateBooking({
					offer: { type, label, contractType, negotiated: offer.negotiated },
					price: undefined,
					publicPrice: undefined,
					config,
				});
			}
			track("mobile_offer_click", {
				offerType: get(offer, "offer.pricing.type", ""),
				minPrice: get(offer, "offer.pricing.minPrice.p", 0),
			});
			history.push({
				pathname: "/booking/search",
			});
		},
		[offers, updateBooking]
	);

	return (
		<div className="offers-overview" data-testid="offers-overview">
			{offers.map(offer => {
				const unit =
					get(offer, "pricing.contractType") === OFFER_CONTRACT_TYPES.RENTAL ? (
						<FormattedMessage id="general.amount.per.accommodation.suffix.label.short" />
					) : (
						<FormattedMessage id="general.amount.per.person.suffix.label.short" />
					);

				const label = get(offer, "pricing.label");

				return (
					<div
						key={label}
						className="offers-overview__item"
						onClick={handleOfferSelect(offer)}
					>
						<OffersOverviewItem
							offerType={get(offer, "pricing.type")}
							nightCount={get(offer, "pricing.minPrice.n")}
							label={label}
							from={get(offer, "pricing.minPrice.p")}
							unit={unit}
							departureDate={get(offer, "pricing.minPrice.dd")}
							departureCity={get(offer, "pricing.minPrice.dc")}
						/>
					</div>
				);
			})}
		</div>
	);
};

OffersOverview.propTypes = {
	offers: PropTypes.array,
	updateBooking: PropTypes.func,
};

OffersOverview.defaultProps = {
	offers: [],
	updateBooking: () => {},
};

export default memo(OffersOverview);
